import type { SearchPageCriteria } from './sharedTypes';

export const serializeCriteria = <FilterName extends string>(
  criteria: SearchPageCriteria<FilterName>,
  filterNames: FilterName[]
) =>
  JSON.stringify({
    query: criteria.query,
    filters: filterNames.reduce<Record<FilterName, string[]>>(
      (serializedFilters, filterName) => {
        serializedFilters[filterName] = [...criteria.filters[filterName]];
        return serializedFilters;
      },
      {} as Record<FilterName, string[]>
    ),
  });

export const serializeListUrlState = <SortValue extends string>(urlState: {
  take: number;
  sort: SortValue | null;
}) =>
  JSON.stringify({
    take: urlState.take,
    sort: urlState.sort,
  });

export const serializeRecord = <Value>(record: Record<string, Value>) =>
  JSON.stringify(
    Object.keys(record)
      .sort()
      .reduce<Record<string, Value>>((serializedRecord, key) => {
        serializedRecord[key] = record[key];
        return serializedRecord;
      }, {})
  );
